import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  // States
  mobileMenuOpen: boolean = false;
  mobileDropdown: string = '';
  activeDropdown: string = '';
  headerScrolled: boolean = false;

  constructor(private renderer: Renderer2) {}

  // Initialization
  ngOnInit(): void {
    // Always start with mobile menu closed
    this.mobileMenuOpen = false;
    this.mobileDropdown = '';
    this.activeDropdown = '';

    this.checkHeaderScroll();
    this.unlockBodyScroll();
  }

  // Destroy
  ngOnDestroy(): void {
    this.unlockBodyScroll();
  }

  // Window Listeners
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.checkHeaderScroll();
  }

  @HostListener('window:resize', [])
  onWindowResize(): void {
    // Force close mobile menu when switching to desktop view
    if (window.innerWidth > 1000) {
      this.mobileMenuOpen = false;
      this.mobileDropdown = '';
      this.unlockBodyScroll();
    }
  }

  @HostListener('document:keydown.escape', [])
  onEscapeKey(): void {
    this.closeMobileMenu();
    this.closeDesktopDropdown();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target) return;

    if (!target.closest('.desktop-nav-item')) {
      this.closeDesktopDropdown();
    }
  }

  // Header Scroll
  private checkHeaderScroll(): void {
    this.headerScrolled = window.pageYOffset > 20;
  }

  // Desktop Dropdown
  toggleDesktopDropdown(dropdown: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.activeDropdown = this.activeDropdown === dropdown ? '' : dropdown;
  }

  closeDesktopDropdown(): void {
    this.activeDropdown = '';
  }

  // Mobile Menu
  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;

    if (!this.mobileMenuOpen) {
      this.mobileDropdown = '';
      this.unlockBodyScroll();
      return;
    }

    this.activeDropdown = '';
    this.lockBodyScroll();
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
    this.mobileDropdown = '';
    this.unlockBodyScroll();
  }

  toggleMobileDropdown(dropdown: string): void {
    this.mobileDropdown = this.mobileDropdown === dropdown ? '' : dropdown;
  }

  // Logo Click
  onLogoClick(): void {
    this.closeMobileMenu();
    this.closeDesktopDropdown();
  }

  // Body Scroll Lock
  private lockBodyScroll(): void {
    this.renderer.addClass(document.body, 'liberica-menu-open');
  }

  private unlockBodyScroll(): void {
    this.renderer.removeClass(document.body, 'liberica-menu-open');
  }
}